import { useMemo, useState } from "react";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Chip,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { useRef } from "react";
import SearchBar from "../../Subcomponents/Search";
import PauseIcon from "@mui/icons-material/Pause";  

const recordingsData = [
  {
    id: 1,
    lead: "Rahul Sharma",
    salesManager: "Rahul Sharma",
    phone: "+91 9003550666",
    date: "22 Mar 2026",
    duration: "1:35",
    status: "completed",
    hasRecording: true,
    project: "Project A",
    unit: "2 BHK",
  },
  {
    id: 2,
    lead: "Sneha Gupta",
    salesManager: "Rahul Sharma",
    phone: "+91 9589785896",
    date: "04 Mar 2026",
    duration: "15:10",
    status: "missed",
    hasRecording: false,
    project: "Project B",
    unit: "1 BHK",
  },
  {
    id: 3,
    lead: "Ravi Verma",
    salesManager: "Rahul Sharma",
    phone: "+91 9154087007",
    date: "11 Mar 2026",
    duration: "5:23",
    status: "pending",
    hasRecording: false,
    project: "Project A",
    unit: "3 BHK",
  },
  {
    id: 4,
    lead: "Neha Jadhav",
    salesManager: "Rahul Sharma",
    phone: "+91 9810467554",
    date: "05 Mar 2026",
    duration: "2:15",
    status: "completed",
    hasRecording: true,
    project: "Project C",
    unit: "2 BHK",
  },
  {
    id: 5,
    lead: "Deepak Patel",
    salesManager: "Rahul Sharma",
    phone: "+91 9846508140",
    date: "12 Mar 2026",
    duration: "2:02",
    status: "missed",
    hasRecording: false,
    project: "Project B",
    unit: "Studio",
  },
  {
    id: 6,
    lead: "Meena Reddy",
    salesManager: "Rahul Sharma",
    phone: "+91 9867857549",
    date: "09 Mar 2026",
    duration: "3:17",
    status: "pending",
    hasRecording: false,
    project: "Project A",
    unit: "2 BHK",
  },
  {
    id: 7,
    lead: "Sanjay Kumar",
    salesManager: "Rahul Sharma",
    phone: "+91 9212602719",
    date: "17 Mar 2026",
    duration: "1:17",
    status: "completed",
    hasRecording: true,
    project: "Project A",
    unit: "1 BHK",
  },
  {
    id: 8,
    lead: "Asha Patil",
    salesManager: "Rahul Sharma",
    phone: "+91 9499824257",
    date: "10 Mar 2026",
    duration: "9:24",
    status: "missed",
    hasRecording: false,
    project: "Project C",
    unit: "2 BHK",
  },
  {
    id: 9,
    lead: "Nitin Desai",
    salesManager: "Rahul Sharma",
    phone: "+91 9657735518",
    date: "10 Mar 2026",
    duration: "10:31",
    status: "pending",
    hasRecording: false,
    project: "Project B",
    unit: "3 BHK",
  },
  {
    id: 10,
    lead: "Rahul Nair",
    salesManager: "Rahul Sharma",
    phone: "+91 9877517806",
    date: "20 Mar 2026",
    duration: "11:09",
    status: "completed",
    hasRecording: true,
    project: "Project A",
    unit: "2 BHK",
  },
  {
    id: 11,
    lead: "Sneha Bhat",
    salesManager: "Rahul Sharma",
    phone: "+91 9248740480",
    date: "04 Mar 2026",
    duration: "9:45",
    status: "missed",
    hasRecording: false,
    project: "Project C",
    unit: "1 BHK",
  },
  {
    id: 12,
    lead: "Ravi Shinde",
    salesManager: "Rahul Sharma",
    phone: "+91 9863680537",
    date: "03 Mar 2026",
    duration: "6:18",
    status: "pending",
    hasRecording: false,
    project: "Project B",
    unit: "Studio",
  },
];

const statusStyles = {
  completed: {
    bg: "#DCFCE7",
    color: "#22C55E",
    label: "completed",
  },
  missed: {
    bg: "#FEE2E2",
    color: "#EF4444",
    label: "missed",
  },
  pending: {
    bg: "#FFEDD5",
    color: "#F59E0B",
    label: "pending",
  },
};

const selectSx = {
  minWidth: 160,
  height: 40,
  bgcolor: "#FFFFFF",
  borderRadius: "8px",
  fontSize: "14px",
  fontWeight: 500,
  color: "#111827",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#E5E7EB",
  },
  "& .MuiSelect-select": {
    py: "9px",
    pr: "34px",
    fontSize: "14px",
    fontWeight: 500,
    fontFamily: "Inter-Medium",
  },
};

export default function CallRecordingsView() {
  const [salesManagerFilter, setSalesManagerFilter] = useState("all");
  const [projectFilter, setProjectFilter] = useState("all");
  const [unitFilter, setUnitFilter] = useState("all");
  const [statusFilter, setStatusFilter] = useState("all");
  const [search, setSearch] = useState("");
  const [playingId, setPlayingId] = useState(null);
const audioRef = useRef(null);

  const filteredData = useMemo(() => {
    return recordingsData.filter((item) => {
      const matchesSM =
        salesManagerFilter === "all" || item.salesManager === salesManagerFilter;
      const matchesProject =
        projectFilter === "all" || item.project === projectFilter;
      const matchesUnit = unitFilter === "all" || item.unit === unitFilter;
      const matchesStatus =
        statusFilter === "all" || item.status === statusFilter;
      const matchesSearch =
        item.lead.toLowerCase().includes(search.toLowerCase()) ||
        item.phone.toLowerCase().includes(search.toLowerCase());

      return (
        matchesSM &&
        matchesProject &&
        matchesUnit &&
        matchesStatus &&
        matchesSearch
      );
    });
  }, [salesManagerFilter, projectFilter, unitFilter, statusFilter, search]);
  const audioCache = new Map();

const getAudioUrl = (id) => {
  if (!audioCache.has(id)) {
    audioCache.set(
      id,
      "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3"
    );
  }
  return audioCache.get(id);
};

const handlePlay = (id) => {
  if (playingId === id) {
    audioRef.current?.pause();
    setPlayingId(null);
    return;
  }

  audioRef.current?.pause();

  const audio = new Audio(getAudioUrl(id));
  audio.play();

  audio.onended = () => setPlayingId(null);

  audioRef.current = audio;
  setPlayingId(id);
};

const handleDownload = (id, name) => {
  const a = document.createElement("a");
  a.href = getAudioUrl(id);
  a.download = `${name}.mp3`;
  a.click();
};

  return (
    <Box
      sx={{
        width: "100%",
        fontFamily: "Inter-Medium",
       pt: 2,
      }}
    >
      <Box sx={{ mb: 4}}>
        <Typography
          sx={{
            fontSize: "17px",
            lineHeight: "28px",
            fontWeight: 600,
            color: "#111827",
            fontFamily: "Inter-Medium",
            display: "inline-block",
            mr: 1.2,
          }}
        >
          Call Recordings
        </Typography>
        <Typography
          component="span"
          sx={{
            fontSize: "14px",
            fontWeight: 500,
            color: "#64748B",
            fontFamily: "Inter-Medium",
          }}
        >
          ({filteredData.length} recordings)
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          flexWrap: "wrap",
          mb: 4,
          fontSize: "10px",
        }}
      >
        {/* <Select
          value={salesManagerFilter}
          onChange={(e) => setSalesManagerFilter(e.target.value)}
          IconComponent={KeyboardArrowDownIcon}
          sx={selectSx}
          size="small"
        >
          <MenuItem value="all">All Sales Managers</MenuItem>
          <MenuItem value="Rahul Sharma">Rahul Sharma</MenuItem>
        </Select>

        <Select
          value={projectFilter}
          onChange={(e) => setProjectFilter(e.target.value)}
          IconComponent={KeyboardArrowDownIcon}
          sx={selectSx}
          size="small"
        >
          <MenuItem value="all">All Projects</MenuItem>
          <MenuItem value="Project A">Project A</MenuItem>
          <MenuItem value="Project B">Project B</MenuItem>
          <MenuItem value="Project C">Project C</MenuItem>
        </Select>

        <Select
          value={unitFilter}
          onChange={(e) => setUnitFilter(e.target.value)}
          IconComponent={KeyboardArrowDownIcon}
          sx={selectSx}
          size="small"
        >
          <MenuItem value="all">All Units</MenuItem>
          <MenuItem value="1 BHK">1 BHK</MenuItem>
          <MenuItem value="2 BHK">2 BHK</MenuItem>
          <MenuItem value="3 BHK">3 BHK</MenuItem>
          <MenuItem value="Studio">Studio</MenuItem>
        </Select>

        <Select
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
          IconComponent={KeyboardArrowDownIcon}
          sx={{ ...selectSx, minWidth: 145 }}
          size="small"
        >
          <MenuItem value="all">All</MenuItem>
          <MenuItem value="completed">Completed</MenuItem>
          <MenuItem value="missed">Missed</MenuItem>
          <MenuItem value="pending">Pending</MenuItem>
        </Select> */}

        {/* Search — shared SearchBar so the fill, radius, icon size and focus
            ring match Leads. 25rem is the Leads standard width
            (.wrapperSearchBar in Leads.module.css); ml:auto keeps it
            right-aligned in this toolbar exactly as before. */}
        <Box sx={{ ml: "auto", width: "25rem", maxWidth: "100%" }}>
          <SearchBar
            id="callRecordingsSearch"
            placeholder="Search by lead..."
            search={(e) => setSearch(e.target.value)}
            width="100%"
          />
        </Box>
      </Box>

      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          border: "1px solid #E5E7EB",
          borderRadius: "14px",
          overflow: "hidden",
          boxShadow: "none",
        }}
      >
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: "#F8FAFC" }}>
              {[
                "Lead",
                "Sales Manager",
                "Phone",
                "Date",
                "Duration",
                "Status",
                "Actions",
              ].map((heading, index) => (
                <TableCell
                  key={heading}
                  align={index === 6 ? "right" : "left"}
                  sx={{
                    borderBottom: "1px solid #E5E7EB",
                    color: "#111827",
                    fontSize: "14px",
                    fontWeight: 600,
                    fontFamily: "Inter-Medium",
                    py: "13px",
                    px: 2,
                    whiteSpace: "nowrap",
                  }}
                >
                  {heading}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {filteredData.map((row) => {
              const currentStatus = statusStyles[row.status];

              return (
                <TableRow
                  key={row.id}
                  hover
                  sx={{
                    "& td": {
                      borderBottom: "1px solid #E5E7EB",
                      py: "14px",
                      px: 2,
                      fontFamily: "Inter-Medium",
                    },
                    "&:last-child td": {
                      borderBottom: 0,
                    },
                  }}
                >
                  <TableCell
                    sx={{
                      color: "#111827",
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    {row.lead}
                  </TableCell>

                  <TableCell
                    sx={{
                      color: "#64748B",
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    {row.salesManager}
                  </TableCell>

                  <TableCell
                    sx={{
                      color: "#64748B",
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.7 }}>
                      <PhoneOutlinedIcon sx={{ fontSize: 15, color: "#94A3B8" }} />
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 500,
                          color: "#64748B",
                          fontFamily: "Inter-Medium",
                        }}
                      >
                        {row.phone}
                      </Typography>
                    </Box>
                  </TableCell>

                  <TableCell
                    sx={{
                      color: "#64748B",
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    {row.date}
                  </TableCell>

                  <TableCell
                    sx={{
                      color: "#64748B",
                      fontSize: "14px",
                      fontWeight: 500,
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.7 }}>
                      <AccessTimeIcon sx={{ fontSize: 15, color: "#94A3B8" }} />
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 500,
                          color: "#64748B",
                          fontFamily: "Inter-Medium",
                        }}
                      >
                        {row.duration}
                      </Typography>
                    </Box>
                  </TableCell>

                  <TableCell>
                    <Chip
                      label={currentStatus.label}
                      size="small"
                      sx={{
                        height: 20,
                        borderRadius: "999px",
                        bgcolor: currentStatus.bg,
                        color: currentStatus.color,
                        "& .MuiChip-label": {
                          px: 1.2,
                          fontSize: "12px",
                          lineHeight: "16px",
                          fontWeight: 500,
                          textTransform: "lowercase",
                          fontFamily: "Inter-Medium",
                        },
                      }}
                    />
                  </TableCell>

                  <TableCell align="right">
                    {row.hasRecording ? (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-end",
                          gap: 0.8,
                        }}
                      >
                        <IconButton
  size="small"
  onClick={() => handlePlay(row.id)}   // ✅ ADDED
>
  {playingId === row.id ? (            // ✅ ADDED
    <PauseIcon sx={{ fontSize: 20 }} />
  ) : (
    <PlayArrowOutlinedIcon sx={{ fontSize: 20 }} />
  )}
</IconButton>

<IconButton
  size="small"
  onClick={() => handleDownload(row.id, row.lead)}  // ✅ ADDED
>
  <FileDownloadOutlinedIcon sx={{ fontSize: 18 }} />
</IconButton>
                      </Box>
                    ) : (
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontStyle: "italic",
                          fontWeight: 500,
                          color: "#64748B",
                          fontFamily: "Inter-Medium",
                        }}
                      >
                        No recording
                      </Typography>
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}